import React from 'react';
import { useHistory } from 'react-router-dom';
import { DetailLayout } from '../../../components/DetailLayout';
import Typography from '../../../components/Typography';
import { translate, translateHTML } from '../../../i18n';
import { useAuthentication } from '../../../state/Authentication';
import './style.scss';

const EID: React.FC = () => {
  const {
    state: { eID },
  } = useAuthentication();
  const history = useHistory();

  React.useEffect(() => {
    if (eID?.rrnr) return;

    history.replace('/gegevens/aanmeldsleutels/rijksregisternummer/toevoegen');
  }, [eID]);

  return (
    <DetailLayout
      backAction="/gegevens"
      backLabel="accessKeys.overview.title"
      title="accessKeys.eid.title"
    >
      <Typography classNames="u-margin-bottom-xs">
        {translateHTML('accessKeys.eid.intro')}
      </Typography>

      <a
        className="ckp-m-eid-contact-link"
        href="https://www.antwerpen.be/info/5360f244b1a8a76a088b45c4/contacteer-stad-antwerpen-voor-meer-info"
        target="_blank"
      >
        {translate('accessKeys.eid.contact')}
      </a>
    </DetailLayout>
  );
};

export default EID;
